import { useState } from "react";
import './UsersPages.css';
import {
    Button,
    Container,
    styled,
    Box,
    CircularProgress,
} from "@mui/material";
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { useGetUserQuery, useGetUsersQuery, useLazyExportUserQuery } from '../../api/api';
import { useNavigate } from "react-router-dom";
import UserTable from "components/tables/UserTable";


const AdminPage = () => {
    const navigate = useNavigate();
    const { data: users = [], isLoading } = useGetUsersQuery();
    const { data: userData } = useGetUserQuery();
    const [triggerUserExport, {
        data: userExportBlob,
        isLoading: isUserExportLoading,
        isSuccess: isUserExportSuccess
    }] = useLazyExportUserQuery();


    const handleClickAddAdmin = () => {
        navigate('/add-admin');
    }

    const siteRole = "Firm Admin"

    const handleExport = async () => {
        try {
            // Triggers the export and get the blob response
            const blobResponse = await triggerUserExport(siteRole).unwrap();
            if (!blobResponse) return;

            // Creates a download link directly from the blob
            const url = window.URL.createObjectURL(blobResponse);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", 'admins-export.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting user data:', error);
        }
    };


    return (
        <StyledContainer>
            <Box>
                {["Sub Super Admin", "Super Admin"].includes(userData?.site_role ?? "") && (
                    <Button
                        type="button"
                        onClick={handleClickAddAdmin}
                        variant="outlined"
                        sx={{ mr: 2, borderRadius: 12 }}
                        startIcon={<AddIcon />}
                    >
                        Add Firm Admins
                    </Button>
                )}
                <Button
                    type="button"
                    onClick={handleExport}
                    variant="outlined"
                    sx={{ mr: 2, borderRadius: 12 }}
                    startIcon={isUserExportLoading ? (
                        <CircularProgress size={16} />
                    ) : (
                        <img src={'/assets/icons/ExportIcon.svg'} alt='Export Icon' />
                    )}
                    disabled={isUserExportLoading}
                >
                    Export Admins
                </Button>
            </Box>
            <UserTable
                users={users}
                usersLoading={isLoading}
                role={siteRole}
            />
        </StyledContainer>
    );
};

export default AdminPage;

const StyledContainer = styled(Container)({
    marginBottom: 24,
});